import React from 'react'
import { useNavigate } from 'react-router'

import { Container, Section } from 'components'
import { useMappedTranslation, usePageTitle } from 'hooks'
import { Button } from 'oneui'

export function PasskeyAuthenticationError() {
  const t = useMappedTranslation()
  const navigate = useNavigate()

  usePageTitle()

  const handleDone = () => {
    navigate(-1)
  }

  return (
    <Container size='small'>
      <Section
        titleSx={{ fontSize: '18px', fontWeight: '700' }}
        description={t('iam.01.Common.Text.Couldnt.sign.in.with.passkey')}
        actions={
          <Button onClick={handleDone} data-testid='Button1BC66D6F'>
            {t('iam.01.Common.Button.OKAY')}
          </Button>
        }
      />
    </Container>
  )
}
